import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'Context/QueryClientContext';
import { billingSplitQueryKey } from 'Data/keys/QueryKeys';
import { RateioApi } from 'Data/Rateio.api';
import {
  IBillingSplitResponse,
  IRateioResponse,
  IRateioUpdateRequest,
} from 'Data/interfaces/Faturamento/IRateio';
import toastHandler from 'Utils/toastHandler';
import { getApiErrorMessage } from 'Utils/ApiErrorUtils';
import i18n from 'i18n';
import { useRateioScope } from './RateioScope';

export const useMutationRateio = () => {
  const { tenantId } = useRateioScope();

  const { mutate, isPending } = useMutation({
    mutationFn: (request: IRateioUpdateRequest) => {
      return RateioApi.updateRateio(request, tenantId);
    },
    onSuccess: (rateio: IRateioResponse) => {
      queryClient.setQueryData<IBillingSplitResponse>(
        billingSplitQueryKey(tenantId),
        (oldData) => (oldData ? { ...oldData, Rateio: rateio } : oldData)
      );
      toastHandler.showSuccess(i18n.t('faturamento:rateio.saveSuccess'));
    },
    onError: (error: unknown) => {
      toastHandler.showError(getApiErrorMessage(error, i18n.t('faturamento:rateio.saveError')));
    },
  });

  return {
    updateRateio: mutate,
    isLoading: isPending,
  };
};
